import React, { Fragment, useEffect, useRef, useMemo } from 'react'
import useStyles from './styles'
import { orderBy } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import {
  Typography,
  CircularProgress,
  Box,
  useMediaQuery
} from '@material-ui/core'
import { getItemBids } from 'actions/items'
import classnames from 'clsx'
import Scrollbars from 'react-scrollbars-custom'
import AutoSizer from 'react-virtualized-auto-sizer'
import UserAction from './UserAction'
import Chat from './Chat'
import ItemAction from './ItemAction'
import animateScrollTo from 'animated-scroll-to'
import { useState } from 'react'
import usePrevious from 'utils/previousHook'

let listRefInterval = null

const ChatList = ({ scrollable = true }) => {
  const classes = useStyles()

  const [scrolled, setScrolled] = useState(false)
  const [listVisible, setListVisible] = useState(false)
  const [listRef, setListRef] = useState(null)

  const contentRef = node => {
    if (node !== null) {
      setListRef(node)
    }
  }

  const isMobile = useMediaQuery('(max-width: 767px)')

  const chatsLoading = useSelector(state => state.event.chatsLoading)
  const eventId = useSelector(state => state.event.event.auction_code)
  const chats = useSelector(state => state.event.chats)
  const previousChatsLength = usePrevious(chats.length)
  const items = useSelector(state => state.items.items)

  const videoControlled = useSelector(
    state =>
      state.stream.cloudinaryVideoControlled &&
      state.stream.egLiveVideoControlled
  )

  const updateScroll = () => {
    try {
      if (!scrolled && listRef && listRef) {
        animateScrollTo(listRef.scrollHeight, {
          elementToScroll: listRef.scrollerElement
        })
      }
    } catch (err) {
      console.log(err)
    }
  }

  const setInitialScrollHeight = () => {
    listRef.scrollTop = listRef.scrollHeight
    setListVisible(true)
  }

  useEffect(() => {
    if (chats.length > previousChatsLength) {
      // chats length has increased
      if (previousChatsLength !== 0) {
        // not the first load
        setTimeout(() => {
          updateScroll()
        }, 150)
      }
    }
  }, [chats.length, previousChatsLength])

  useEffect(() => {
    if (listRef) {
      setTimeout(() => {
        setInitialScrollHeight()
      }, 1000)
    }
  }, [listRef, videoControlled])

  const renderEngagement = (engagement, i) => {
    if (engagement.type === 'chat') {
      // render chat
      return <Chat data={engagement} key={i} />
    } else if (engagement.type === 'item') {
      // render item close / open
      return (
        <ItemAction
          data={engagement}
          item={items.find(x => {
            return parseInt(x.item_id, 10) === parseInt(engagement.item_id, 10)
          })}
          key={i}
        />
      )
    } else {
      return <UserAction data={engagement} key={i} />
    }
  }

  const handleScrollStop = ({ scrollTop, scrollHeight, clientHeight }) => {
    setScrolled(scrollHeight - clientHeight - scrollTop > 100)
  }

  const orderedChats = useMemo(() => {
    return orderBy(chats, ['sortable_date'], ['asc'])
  }, [chats])

  return (
    <Fragment>
      {chats && chats.length > 0 && (
        <Fragment>
          <Box className={classes.scrollArea}>
            <AutoSizer>
              {({ height, width }) =>
                React.cloneElement(
                  <Scrollbars
                    style={{
                      height,
                      width
                    }}
                    noScroll={!scrollable || isMobile}
                    removeTracksWhenNotUsed
                    disableTracksWidthCompensation
                    onScrollStop={handleScrollStop}
                    className={classnames(classes.list, {
                      [classes.listVisible]: listVisible
                    })}
                  >
                    {orderedChats.map((engagement, i) =>
                      renderEngagement(engagement, i)
                    )}
                  </Scrollbars>,
                  { ref: contentRef }
                )
              }
            </AutoSizer>
          </Box>
        </Fragment>
      )}
      {!chats && chatsLoading && (
        <div className={classes.bidsLoading}>
          <Typography variant="h4" className={classes.loadingTypography}>
            Loading chats
          </Typography>
          <CircularProgress />
        </div>
      )}
      {!chats && !chatsLoading && (
        <Typography variant="h4" className={classes.noBidsTypography}>
          No chats Have Been Made Yet
        </Typography>
      )}
    </Fragment>
  )
}

export default ChatList



// WEBPACK FOOTER //
// ./src/components/EngagementsBoard/ChatList/index.jsx